module.exports = __webpack_public_path__ + "static/media/18ECA50.371e9b0f.jpg";